import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  flexItem: {
    padding: "24px",
    borderRadius: "24px",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.5)",
    boxShadow: "0 10px 40px rgba(77, 18, 119, 0.04)",
    width: "100%",
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  headerBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingBottom: "18px",
    marginBottom: "24px",
    borderBottom: "1px solid rgba(77, 18, 119, 0.05)",
    fontFamily: "Poppins",
  },
  headerText1: {
    fontWeight: 600,
    fontSize: "11px",
    color: "#B0B0C0",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    marginBottom: "4px",
  },
  headerText2: {
    fontWeight: 800,
    fontSize: "20px",
    color: "#1A1A2E",
    letterSpacing: "-0.5px",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    flex: 1,
  },
  chartWrapper: {
    display: "none",
  },
  totalBadge: {
    display: "none",
  },
  totalCount: {
    fontSize: "28px",
    fontWeight: 800,
    color: "#1A1A2E",
    lineHeight: 1,
    fontFamily: "Poppins",
  },
  totalLabel: {
    fontSize: "10px",
    fontWeight: 700,
    color: "#A0A0C0",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginTop: "2px",
    fontFamily: "Poppins",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    width: "100%",
  },
  sourceCard: {
    padding: "16px",
    borderRadius: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    border: "1px solid rgba(0, 0, 0, 0.03)",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#fff",
      boxShadow: "0 8px 25px rgba(77, 18, 119, 0.06)",
      transform: "translateY(-4px)",
      borderColor: "rgba(77, 18, 119, 0.1)",
    },
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  sourceIconBox: {
    width: "32px",
    height: "32px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  sourceCount: {
    fontWeight: 800,
    fontSize: "18px",
    color: "#1A1A2E",
    fontFamily: "Poppins",
  },
  sourceLabel: {
    fontWeight: 600,
    fontSize: "13px",
    color: "#666",
    fontFamily: "Poppins",
  },
  viewButton: {
    fontSize: "11px",
    fontWeight: 700,
    color: "#4D1277",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    cursor: "pointer",
    padding: "6px 0",
    textAlign: "center",
    borderRadius: "8px",
    backgroundColor: "rgba(77, 18, 119, 0.05)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#4D1277",
      color: "#fff",
    },
  },
}));

export default useStyles;
